import axios from 'axios'

const TransferService = {
  async get (params = {}) {
    return axios.get('prd/inter-warehouse-transfer/requests', { params })
  },

  async histories (params = {}) {
    return axios.get('prd/reports/inter-warehouse-transfer/request-histories', { params })
  },

  async show (id) {
    return axios.get(`prd/inter-warehouse-transfer/requests/${id}`)
  },

  async post (params = {}) {
    return axios.post('prd/inter-warehouse-transfer/requests', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`prd/inter-warehouse-transfer/requests/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`prd/inter-warehouse-transfer/requests/${data.id}`, { data })
  }
}

export default TransferService
